import {isLive, serializeQuery} from "./tools";
import {ApiError} from "./errors";

const testing = true;
const apiDebug = true;
const showLogs = true;

let apiLocation = testing && !isLive() ? "http://api.localhost" : "https://api.festen.dk";

function logApiCall(method, call, data, postData, start) {
	if (!isLive() && showLogs) {
		const time = new Date() - start;
		const style = "font-weight: bold";
		
		console.groupCollapsed(`${method.toUpperCase()}: ${call}`);
		console.log("%cPostData: ", style, postData);
		console.log("%cReturn: ", style, data);
		console.log("%cTime: ", style, time < 1000 ? "< 1s" : `${time / 1000}s`);
		console.groupEnd();
	}
}

function logApiError(method, call, error, display = true, errorId = null, postData, start) {
	if (!isLive() && showLogs) {
		const time = new Date() - start;
		const style = "font-weight: bold; color: red";
		
		console.group(`%cERROR: ${method.toUpperCase()}: ${call}`, "color:red");
		console.log("%cPostData: ", style, postData);
		if (errorId) console.log("%cError ID: ", style, errorId);
		console.log("%cError: ", style, error);
		console.log("%cDisplayed: ", style, display);
		console.log("%cTime: ", style, time < 1000 ? "< 1s" : `${time / 1000}s`);
		console.groupEnd();
	}
}

export async function apiCallAsync(token, method, call, postData = {}, files) {
	let config = {
		method: method,
		headers: {
			'Accept': 'application/json',
			'Authorization': 'Bearer ' + token,
			'debug': !isLive() && apiDebug ? 1 : 0
		},
		cache: "no-store"
	};
	
	if (files == null)
		config.headers['Content-Type'] = 'application/json';
	
	if (method.toLowerCase() === "get") {
		if (postData != null && Object.keys(postData).length > 0)
			call += "?" + serializeQuery(postData);
	} else {
		if (files) {
			console.log(files);
			let formData = new FormData();
			for (let key in postData) {
				if (!postData.hasOwnProperty(key)) continue;
				formData.append(key, postData[key]);
			}
			for (let key in files) {
				if (!files.hasOwnProperty(key)) continue;
				formData.append(key, files[key]);
			}
			
			config.body = formData;
		} else {
			config.body = JSON.stringify(postData != null ? postData : {});
		}
	}
	const start = new Date();
	const data = await fetch(apiLocation + "/" + call.replace(/^\//, ''), config);
	
	if (data === null)
		throw ApiError("Failing silently", false, method, call);
	
	let json;
	
	try {
		json = await data.json();
	} catch (e) {
		logApiError(method, call, "JSON Error", true, null, postData);
		throw ApiError("JSON Error", true, method, call, postData, start);
	}
	
	if (data.ok) {
		logApiCall(method, call, json, postData, start);
		return json;
	} else {
		logApiError(method, call, json.message, json.display, json.errorId, json.postData, start);
		throw ApiError(json.message, json.display, method, call, postData);
	}
}

export function apiCall(token, method, call, successCallback, postData, errorCallback, files) {
	
	apiCallAsync(token, method, call, postData, files).then(
		data => {
			if (typeof successCallback === "function")
				successCallback(data);
		},
		e => {
			if (typeof errorCallback === "function")
				errorCallback(e.message, e.display);
		}
	);
}

export function getUserId(token) {
	if (token == null) return null;
	const tokenData = JSON.parse(atob(token.split(".")[1] || ""));
	return tokenData.uid || null;
}

export function getUserData(token) {
	if (token == null) return null;
	const tokenData = JSON.parse(atob(token.split(".")[1] || ""));
	return tokenData || null;
}

export function getImage(id, small = false) {
	if (!id) return "https://media.festen.dk/no_image.jpg";
	return `${apiLocation}/image/${id}` + (small ? "?size=small" : "");
}


// WEBPACK FOOTER //
// ./src/lib/api.js